import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { MdDelete } from 'react-icons/md';
import { useUserAuth } from '../../context/UserAuthContext';
import axios from 'axios';
import dayjs from 'dayjs';

const AddStaf = () => {
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const { user , token} = useUserAuth();
    const merchant_id = user?.uid;

    const [staff, setStaff] = useState([]);
    console.log(staff)
    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const [data, setData] = useState({
        name: '',
        contact: '',
        date: '',
        amount: '',
        salarytype: '',
        role: ''
    });

    useEffect(() => {
        if (!merchant_id) return;
        getStaffData();
    }, [merchant_id, token]);

    const getStaffData = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${base_url}/api/v1/staff/staff/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            setStaff(res.data.data);
            setLoading(false);
        } catch (error) {
            console.error(error);
            toast.error('Failed to fetch staff data');
            setLoading(false);
        }
    };

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const formHandler = (e) => {
        const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    const btnHandler = async () => {
        const { name, contact, date, amount, salarytype, role } = data;
        if (!name || !contact || !date || !amount || !salarytype || !role) {
            return toast.error('Please fill all fields');
        }
        try {
            const payload = { merchant_id, name, contact, date, amount, salarytype, role };
            const response = await axios.post(`${base_url}/api/v1/staff/submit-staff`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.status === 200 || response.status === 201) {
                toast.success('Staff added successfully');
                setData({ name: '', contact: '', date: '', amount: '', salarytype: '', role: '' });
                handleClose();
                getStaffData();
            } else {
                toast.error('Failed to add staff');
            }
        } catch (error) {
            console.error(error);
            toast.error('Something went wrong');
        }
    };

    const deleteStaff = async (id) => {
        const confirmDelete = window.confirm('Are you sure you want to delete this staff?');
        if (!confirmDelete) return;
        try {
            const res = await axios.delete(`${base_url}/api/v1/staff/staff-delete/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (res.status === 200 || res.status === 204) {
                toast.success('Staff deleted successfully');
                setStaff(prev => prev.filter(stf => stf.id !== id));
            } else {
                toast.error('Failed to delete staff');
            }
        } catch (err) {
            console.error(err);
            toast.error('An error occurred during deletion');
        }
    };

    return (
        <>
            <div className="page-wrapper">
                <div className="container-fluid">
                    <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add Staff</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form>
                                <div className="form-group mb-2">
                                    <label>Full Name *</label>
                                    <input type="text" name="name" value={data.name} onChange={formHandler} className="form-control" />
                                </div>
                                <div className="form-group mb-2">
                                    <label>Contact Number *</label>
                                    <input type="tel" name="contact" maxLength="10" value={data.contact} onChange={formHandler} className="form-control" />
                                </div>
                                <div className="form-group mb-2">
                                    <label>Role *</label>
                                    <select name="role" value={data.role} onChange={formHandler} className="form-control">
                                        <option value="">Select Role</option>
                                        <option value="employee">Employee</option>
                                        <option value="manager">Manager</option>
                                        <option value="Labor">Labor</option>
                                    </select>
                                </div>
                                <div className="form-group mb-2">
                                    <label>Salary Calculation Date *</label>
                                    <input type="date" name="date" value={data.date} onChange={formHandler} className="form-control" />
                                </div>
                                <div className="form-group mb-2">
                                    <label>Salary Type *</label><br />
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="salarytype" value="monthly" checked={data.salarytype === 'monthly'} onChange={formHandler} />
                                        <label className="form-check-label">Monthly</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="salarytype" value="daily" checked={data.salarytype === 'daily'} onChange={formHandler} />
                                        <label className="form-check-label">Daily</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="salarytype" value="hourly" checked={data.salarytype === 'hourly'} onChange={formHandler} />
                                        <label className="form-check-label">Hourly</label>
                                    </div>
                                </div>
                                <div className="form-group mb-2">
                                    <label>Amount *</label>
                                    <input type="number" name="amount" value={data.amount} onChange={formHandler} className="form-control" />
                                </div>
                            </form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={btnHandler}>Submit</Button>
                        </Modal.Footer>
                    </Modal>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <input type="text" placeholder="Search Staff..." className="form-control w-50" />
                        <Button variant="success" onClick={handleShow}>Add Staff</Button>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                            <thead className="table-light">
                                <tr>
                                    <th>S.No.</th>
                                    <th>Name</th>
                                    <th>Contact</th>
                                    <th>Salary Date</th>
                                    <th>Salary Type</th>
                                    <th>Amount</th>
                                    <th>Role</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    Array.from({ length: 3 }).map((_, i) => (
                                        <tr key={i}>
                                            {Array.from({ length: 8 }).map((_, j) => (
                                                <td key={j}><Skeleton /></td>
                                            ))}
                                        </tr>
                                    ))
                                ) : staff?.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className="text-center">No staff found</td>
                                    </tr>
                                ) : (
                                    staff?.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.name}</td>
                                            <td>{item.mob_no}</td>
                                            <td>{dayjs(item.date).format('DD-MM-YYYY')}</td>
                                            <td>{item.salary_type}</td>
                                            <td>{item.amount}</td>
                                            <td>{item.salary_role}</td>
                                            <td>
                                                <Button variant="danger" onClick={() => deleteStaff(item.id)}><MdDelete /></Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddStaf;